import _ from 'lodash';

import {
  QueryTier1ReturnAuthorizationsFilterInput,
  useTier1ReturnAuthorizationsActivity_TableLazyQuery
} from 'generated/graphql';

import { NetSuiteRecordChip } from 'modules';
import { DateTime } from 'luxon';
import { listQueryUtil } from 'iron-forge-react-modules';
import * as types from './types';



export interface IReturnAuthorization {
  id: string;
  clientName: string;
  intxNumber: string;
  referenceNumber: string;
  itemReceiptDate: DateTime | null;
  itemReceiptWriteStatus: NetSuiteRecordChip.IWriteStatus;
  returnAuthorizationWriteStatus: NetSuiteRecordChip.IWriteStatus;
  observedIssue: string;
  productName: string;
  productSku: string;
  requestDate: DateTime;
  serialNumber: string;
  shippingLabelUrl: string;
}



const useListQuery = listQueryUtil.genUseListQuery<types.IColumnId>();



export interface IData {
  returnAuthorizations: IReturnAuthorization[];
}

export function useQuery(initialFilter: types.IFilter) {
  return useListQuery({
    useLazyQuery: useTier1ReturnAuthorizationsActivity_TableLazyQuery,
    clientColumn2GqlSortField: {
      referenceNumber: 'referenceNumber'
    },
    defaultFilterArgs: {
      inState: initialFilter?.inState,
      searchText: initialFilter.searchText ?? '',
      storeId: initialFilter.storeId
    },
    initQuerySort: {
      columnId: 'requestedDate',
      direction: 'descending'
    },
    genFilter2GqlFilter: (filter: types.IFilter) =>
      (): QueryTier1ReturnAuthorizationsFilterInput => ({
        storeId: initialFilter?.storeId ?? filter.storeId,
        inState: initialFilter?.inState ?? filter.inState,
        omniFreeText: initialFilter?.searchText ?? filter.searchText
      }),
    gqlResultData2GqlPageInfo: gql => gql?.tier1ReturnAuthorizations.pageInfo,
    gqlResultData2TupleData: (gql): IData => ({
      returnAuthorizations: _.map(gql.data?.tier1ReturnAuthorizations.nodes ?? [], (node): IReturnAuthorization => ({
        id: node.id,
        clientName: node.group.store.name,
        itemReceiptDate: node.itemReceipt ? DateTime.fromISO(node.itemReceipt.createdTimestamp) : null,
        returnAuthorizationWriteStatus: NetSuiteRecordChip.genWriteStatus({
          netSuiteRecord: node.netSuiteRecord,
          writeRequest: node.netSuiteWriteRequest
        }),
        intxNumber: node.returnNumber,
        itemReceiptWriteStatus: NetSuiteRecordChip.genWriteStatus({
          writeRequest: node.itemReceipt?.netSuiteWriteRequest,
          netSuiteRecord: node.itemReceipt?.netSuiteRecord
        }),
        observedIssue: node.observation?.reasonText ?? '',
        productName: node.item.name,
        productSku: node.item.sku,
        referenceNumber: node.group.referenceNumber,
        requestDate: DateTime.fromISO(node.createdTimestamp),
        serialNumber: node.expectedSerialNumber,
        shippingLabelUrl: node.carton?.shipment?.labelUrl ?? ''
      }))
    })
  });
}
